var _circle, _path, _path2, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourseLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.548 22.7439C12.6241 22.4815 12.7805 22.2496 12.9953 22.0809L17.467 18.5677L19.3204 20.9268L21.1737 23.2858L16.7021 26.7989C16.4873 26.9677 16.2249 27.0648 15.952 27.0767C13.634 27.177 11.9019 24.9723 12.548 22.7439Z",
    stroke: "#6D31ED",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0479 12.9233C24.775 12.9352 24.5127 13.0323 24.2978 13.2011L19.8262 16.7142L21.6795 19.0732L23.5329 21.4323L28.0046 17.9191C28.2194 17.7504 28.3758 17.5185 28.4519 17.2561C29.098 15.0277 27.3659 12.823 25.0479 12.9233Z",
    stroke: "#6D31ED",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16.9615,
    y1: 22.7799,
    x2: 23.2523,
    y2: 17.8377,
    stroke: "#6D31ED",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseLink);
export default __webpack_public_path__ + "static/media/course_link.6c6713dbee14cd3a932fdf8dafc27e54.svg";
export { ForwardRef as ReactComponent };